/* eslint-disable react-hooks/exhaustive-deps */
import AppContext from "AppContext";
import { useState, useEffect, useContext } from "react";
import { hasElements } from "utils/arrays";

function useMessageVariables({ message }) {
    const [participant, setParticipant] = useState(undefined);

    const { messaging } = useContext(AppContext);

    const identity = messaging.profile;

    const [state, setState] = useState({
        isIncomming: undefined,
        isOutgoing: undefined,
        hasMedia: undefined,
        isSMS: undefined,
        isCHAT: undefined,
    });

    useEffect(() => {
        const getParticipantAsync = async () => {
            let isCacheDefined = false;
            const cachedParticipants = localStorage.getItem("participants");
            const cachedParticipantsArray = cachedParticipants && JSON.parse(cachedParticipants);
            if (hasElements(cachedParticipantsArray)) {
                isCacheDefined = true;
                const cachedParticipant = cachedParticipantsArray.find((x) => x.sid === message.participantSid);
                if (cachedParticipant) {
                    setParticipant(cachedParticipant);
                    return;
                }
            }

            const _participant = await message.getParticipant();
            setParticipant(_participant);

            if (isCacheDefined) {
                cachedParticipantsArray.push(_participant.state);
                localStorage.setItem("participants", JSON.stringify(cachedParticipantsArray));
            } else {
                localStorage.setItem("participants", JSON.stringify([_participant.state]));
            }
        };

        getParticipantAsync();
    }, []);

    useEffect(() => {
        const newState = {
            isIncomming: message && message.author !== identity,
            isOutgoing: message && message.author === identity,
            hasMedia: message && message.type === "media",
            isSMS: participant && participant.type === "sms",
            isCHAT: participant && participant.type === "chat",
        };
        setState(newState);
    }, [message, participant, identity]);

    const getDirectionString = () => (message && message.author === identity ? "outgoing" : "incomming");

    return { ...state, getDirectionString };
}

export default useMessageVariables;
